import axios from '../../../apis/Api'
import history, { logout } from '../../../history'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import { GET_LOAN_DISBURSEMENT_REPORT } from '../../../Types'
import fileSaver from 'file-saver'
import * as XLSX from 'xlsx'

export const getLoanDisbursementReport = (requestData) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post(`api/Reports/GetLoanDisbursementReport`, requestData)
    .then(({ data }) => {
      if (data)
        dispatch({
          type: GET_LOAN_DISBURSEMENT_REPORT,
          payload: data,
        })
      dispatch(hideLoading())
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post(`api/Reports/GetLoanDisbursementReport`, requestData)
    .then(({ data }) => {
      const outputFilename = `LOAN_DISBURSEMENT_Report_${Date.now()}`
      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      const fileExtension = '.xlsx'

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData)
        if (ws) {
          var range = XLSX.utils.decode_range(ws['!ref'])
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + '1' // <-- first row, column number C
            if (!ws[address]) continue
            ws[address].v =
                ws[address].v == 'vizId'
                ? 'VIZ ID'
                // : ws[address].v == 'dateStr'
                // ? 'Date'
                : ws[address].v == 'shopCode'
                ? 'Shop Code'
                : ws[address].v == 'shopName'
                ? 'Shop Name'
                : ws[address].v == 'lender'
                ? 'Financier'
                : ws[address].v == 'distibutor'
                ? 'Distributor'
                : ws[address].v == 'distCenter'
                ? 'Dist Center'
                : ws[address].v == 'invoiceAmt'
                ? 'Invoice Amount'
                : ws[address].v == 'loanAmt'
                ? 'Loan Amount'
                : ws[address].v == 'statusStr'
                ? 'Disbursement Status'
                : ws[address].v == 'qrCode'
                ? 'DLM Till'
                : ws[address].v == 'dlmName'
                ? 'DLM Name'
                :ws[address].v == 'cnic'
                ? 'CNIC No'
                :ws[address].v == 'mobileNo'
                ? 'Mobile No'
                :ws[address].v == 'dueDateStr'
                ? 'Due Date'
                :ws[address].v == 'transactionDateStr'
                ? 'Invoice Date'
                :ws[address].v == 'invoice'
                ? 'Invoice No'
                :ws[address].v == 'loanId'
                ? 'Loan ID'
                :ws[address].v == 'loanDateStr'
                ? 'Loan Date'
                :ws[address].v == 'profitAmt'
                ? 'Profit Amount'
                :ws[address].v == 'totalPayable'
                ? 'Total Payable'
                :ws[address].v == 'creditDuration'
                ? 'Credit Duration'
                :ws[address].v == 'paidAmount'
                ? 'Paid Amount'
                :ws[address].v == 'outStandingAmount'
                ? 'Outstanding'
                :ws[address].v == 'availableLimit'
                ? 'Available Limit'

                : ws[address].v
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        }
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const fileData = new Blob([excelBuffer], { type: fileType })
        fileSaver.saveAs(fileData, fileName + fileExtension)
      }
      exportToCSV(data?.report, '', outputFilename)
      dispatch(hideLoading())
    })

    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}
